
export default {
  name: 'VsPaginationTotal',
  inject: ['pagination', '$t']
}
